/**
 * Agent Module
 */
import helper from 'util/helpers';
const getDefaultState = () => {
  return {
    agentId: null,
    ticketAgentId: null,
    agentWorkingStatus: null,
    authorities: null,
    email: null,
    loginId: null,
    accountId: null,
    name: null,
    agentMappingBrandViews: [],
    currentBrandId: null,
    currentBrandName: null,
    currentTicketBrandId: null,
    currentTicketBrandName: null,
    customTemplates: [],
    updatedCustomerInfos: [],
    treeNodeSelectedItem: {},
    currentParentBrandId: null,
    moduleChannelId: null
  };
};
const state = getDefaultState();

const getters = {
  agentId: (state) => {
    return state.agentId;
  },
  email: (state) => {
    return state.email;
  },
  name: (state) => {
    return state.name;
  },
  agentMappingBrandViews: (state) => {
    return state.agentMappingBrandViews;
  },
  ticketAgentId: (state) => {
    return state.ticketAgentId;
  },
  loginId: (state) => {
    return state.loginId;
  },
  getAccountId: (state) => {
    return state.accountId;
  },
  authorities: (state) => {
    return state.authorities;
  },
  customTemplates: (state) => {
    return state.customTemplates;
  },
  agentWorkingStatus: (state) => {
    return state.agentWorkingStatus;
  },
  currentBrandId: (state) => {
    return state.currentBrandId;
  },
  currentBrandName: (state) => {
    return state.currentBrandName;
  },
  currentTicketBrandId: (state) => {
    return state.currentTicketBrandId;
  },
  currentTicketBrandName: (state) => {
    return state.currentTicketBrandName;
  },
  updatedCustomerInfos: (state) => {
    return state.updatedCustomerInfos;
  },
  getUpdatedCustomerInfo: (state) => (userKey) => {
    return state.updatedCustomerInfos.find((customerInfo) => userKey === customerInfo.userKey);
  },
  findCustomerName: (state) => (customerInfoView) => {
    let customerInfos = state.updatedCustomerInfos.find((customerInfo) => customerInfoView.userKey === customerInfo.userKey);
    return helper.longTextLengthAdjust(
      customerInfos && customerInfos.name ? customerInfos.name : customerInfoView.name ? customerInfoView.name : customerInfoView.userKey,
      4
    );
  },
  findCustomerPhoneNumber: (state) => (customerInfoView) => {
    let customerInfos = state.updatedCustomerInfos.find((customerInfo) => customerInfoView.userKey === customerInfo.userKey);
    return customerInfos && customerInfos.phoneNumber
      ? customerInfos.phoneNumber
      : customerInfoView.phoneNumber
      ? customerInfoView.phoneNumber
      : undefined;
  },
  findCustomerFullName: (state) => (customerInfoView) => {
    let customerInfos = state.updatedCustomerInfos.find((customerInfo) => customerInfoView.userKey === customerInfo.userKey);
    return customerInfos && customerInfos.name !== undefined && customerInfos.name
      ? customerInfos.name
      : customerInfoView.name !== undefined && customerInfoView.name
      ? customerInfoView.name
      : customerInfoView.userKey;
  },
  findCustomerEmail: (state) => (customerInfoView) => {
    let customerInfos = state.updatedCustomerInfos.find((customerInfo) => customerInfoView.userKey === customerInfo.userKey);
    return customerInfos && customerInfos.email ? customerInfos.email : customerInfoView.email ? customerInfoView.email : undefined;
  },
  findCustomerUserKey: (state) => (customerInfoView) => {
    let customerInfos = state.updatedCustomerInfos.find((customerInfo) => customerInfoView.userKey === customerInfo.userKey);
    return customerInfos && customerInfos.userKey ? customerInfos.userKey : customerInfoView.userKey ? customerInfoView.userKey : undefined;
  },
  findCustomerMemo: (state) => (customerInfoView) => {
    let customerInfos = state.updatedCustomerInfos.find((customerInfo) => customerInfoView.userKey === customerInfo.userKey);
    return customerInfos && customerInfos.memo ? customerInfos.memo : customerInfoView.memo ? customerInfoView.memo : undefined;
  },
  findCustomerChannelName: (state) => (customerInfoView) => {
    let customerInfos = state.updatedCustomerInfos.find((customerInfo) => customerInfoView.channelName === customerInfo.channelName);
    return customerInfos && customerInfos.channelName
      ? customerInfos.channelName
      : customerInfoView.channelName
      ? customerInfoView.channelName
      : undefined;
  },
  treeNodeSelectedItem: (state) => {
    return state.treeNodeSelectedItem;
  },
  currentParentBrandId: (state) => {
    return state.currentParentBrandId;
  },
  moduleChannelId: (state) => {
    return state.moduleChannelId;
  }
};

const actions = {};

const mutations = {
  setAgentState(state, parsedInfo) {
    this.$token = parsedInfo || null;
    state.agentId = parsedInfo.agentId;
    state.loginId = parsedInfo.loginId;
    state.accountId = parsedInfo.accountId;
    state.name = parsedInfo.name;
    state.email = parsedInfo.email;
    state.authorities = parsedInfo.authorities;
    state.ticketAgentId = parsedInfo.ticketAgentId;
    state.agentMappingBrandViews = parsedInfo.agentMappingBrandViews;
  },
  setAgentWorkingStatus(state, workingStatus) {
    state.agentWorkingStatus = workingStatus;
  },
  setCustomTemplates(state, payload) {
    if (Array.isArray(payload)) {
      state.customTemplates = payload;
    } else if (typeof payload === 'object') {
      const oneKey = state.customTemplates.find((template) => template.templateId === payload.templateId);
      if (!oneKey) {
        state.customTemplates.push(payload);
        return;
      }
      oneKey.message = payload.message;
    }
  },
  deleteCustomTemplate(state, customTemplateInfo) {
    state.customTemplates.splice(state.customTemplates.indexOf(customTemplateInfo), 1);
  },
  changeCurrentBrandId(state, brandId) {
    state.currentBrandId = brandId;
  },
  changeCurrentBrandName(state, brandName) {
    state.currentBrandName = brandName;
  },
  // changeTicketBrandId(state, brandId) {
  //   state.currentTicketBrandId = brandId;
  // },
  changeTicketBrandName(state, brandName) {
    state.currentTicketBrandName = brandName;
  },
  changeName(state, name) {
    state.name = name;
  },
  pushUpdateCustomerInfo(state, payload) {
    let index = state.updatedCustomerInfos.findIndex((customerInfo) => payload.userKey === customerInfo.userKey);
    if (index === -1) {
      state.updatedCustomerInfos.push(payload);
    } else {
      state.updatedCustomerInfos[index] = payload;
      state.updatedCustomerInfos.push();
    }
  },
  CLEAR_AGENT(state) {
    Object.assign(state, getDefaultState());
  },
  changeTreeNodeSelectedItem(state, payload) {
    state.treeNodeSelectedItem = payload;
  },
  changeCurrentParentBrandId(state, brandId) {
    state.currentParentBrandId = brandId;
  },
  changeModuleChannelId(state, brandId) {
    state.moduleChannelId = brandId;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/agent/index.js